export const CONTENT_MAX_WIDTH = 1320;
export const CONTENT_GRID_PROPS = {
  xs: 12,
  md: 12,
  lg: 10,
  xl: 8,
};
export const CONTENT_SIDE_PADDING = "1rem";
export const FEATURE_SECTION_RADIUS = 24;
export const FEATURE_SECTION_EDGE_INSET = ".4rem";

export const CONTENT_FRAME_STYLE = {
  width: "100%",
  maxWidth: `${CONTENT_MAX_WIDTH}px`,
  margin: "0 auto",
};

export const CONTENT_INNER_STYLE = {
  paddingLeft: CONTENT_SIDE_PADDING,
  paddingRight: CONTENT_SIDE_PADDING,
};
